import * as types from '../types';

export default {
  [types.GET_VISIT_LIST](state, data) {
    state.visitList = data;
  },
  [types.GET_VISIT_DETAIL](state, data) {
    state.visitDetail = data;
  },
  [types.GET_STATISTICS_VISIT_TYPE](state, data) {
    state.visitTypeList = data.results;
  },
  [types.GET_VISIT_TEAMS](state, data) {
    state.visitTeams = data;
  },

  [types.GET_VISIT_CUSTOMER_DATA_LIST](state, data) {
    state.visitCustomerDataList = data;
  },
  [types.GET_VISIT_MEDICAL_CUSTOMER_DATA_LIST](state, data) {
    state.visitMedicalCustomerDataList = data;
  },
  [types.GET_VISIT_CUSTOMER_SALESMAN_DATA_LIST](state, data) {
    state.visitCustomerSalesmanDataList = data;
  },

  [types.GET_VISIT_CUSTOMER_CONVERT_DATA_LIST](state, data) {
    state.visitCustomerConvertDataList = data;
  },

  [types.GET_VISIT_BUSINESS_DATA_LIST](state, data) {
    state.visitBusinessDataList = data;
  },
  [types.GET_VISIT_BUSINESS_CONVERT_DATA_LIST](state, data) {
    state.visitBusinessConvertDataList = data;
  },
  [types.GET_VISIT_CLUES_DATA_LIST](state, data) {
    state.visitCluesDataList = data;
  },
};
